<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Check Out Device</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3">
              <label for="name" class="form-label">Organisation</label>

              <div class="input-group mb-1">
                <span class="input-group-text bg-white border-end-0"
                  ><i class="bi bi-search"></i></span
                ><input
                  type="text"
                  class="form-control border-start-0"
                  placeholder="Filter..."
                  v-model="filter.organisation_name"
                  v-on:keyup="filter_organisations"
                />
              </div>

              <select class="form-control" v-model="organisation_ref">
                <option value="">Please select</option>
                <option
                  v-for="organisation in organisations_filtered"
                  v-bind:key="organisation.uuid"
                  :value="organisation.uuid"
                >
                  {{ organisation.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label for="name" class="form-label">Assignee</label>

              <div class="input-group mb-1">
                <span class="input-group-text bg-white border-end-0"
                  ><i class="bi bi-search"></i></span
                ><input
                  type="text"
                  class="form-control border-start-0"
                  placeholder="Filter..."
                  v-model="filter.assignee_name"
                  v-on:keyup="filter_assignees"
                />
              </div>

              <select class="form-control" v-model="assignee_id">
                <option value="">Please select</option>
                <option
                  v-for="assignee in assignees_filtered"
                  v-bind:key="assignee.uuid"
                  :value="assignee.uuid"
                >
                  {{ assignee.full_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-primary w-100"
                @click="checkout_device"
              >
                Checkout Device
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Storage from "../../helpers/storage";
import Utils from "../../helpers/utils";

export default {
  name: "DeviceCheckout",
  props: ["id"],
  data() {
    return {
      eui: "",
      organisation_ref: "",
      assignee_id: "",
      organisations: [],
      organisations_filtered: [],
      assignees: [],
      assignees_filtered: [],
      organisation_filter_timeout: null,
      assignee_filter_timeout: null,
      filter: {
        organisation_name: "",
        assignee_name: "",
      },
    };
  },
  mounted() {
    this.emitter.on("device_details_loaded", (data) => {
      this.eui = data.eui ? data.eui : "";
      this.organisation_ref = data.organisation ? data.organisation.id : "";
      this.assignee_id = data.assignee ? data.assignee.id : "";
    });

    this.fetch_organisations();
  },
  methods: {
    sortByName(one, two) {
      return one.name > two.name;
    },
    sortByFullName(one, two) {
      return one.full_name > two.full_name;
    },
    axeHeaders() {
      var axeTokens = Storage.get("tokens", true);

      return {
        Authorization: 'Bearer ' + axeTokens.access_token,
      };
    },
    fetch_organisations() {
      axios
        .get(process.env.MIX_AXE_API_URL + "organisations?items=100", {
          headers: this.axeHeaders(),
        })
        .then((response) => {
          this.organisations = Utils.axeCollection(response.data).sort(this.sortByName);

          this.organisations_filtered = this.organisations;

          this.assignee_id = "";

          this.fetch_assignees();
        })
        .catch((error) => {
          process.appdata.refreshTokens();
        });
    },
    fetch_assignees(search = "") {
      if ("" === this.organisation_ref) {
        this.assignee_id = "";
        this.assignees = [];
        this.assignees_filtered = [];
        return;
      }

      let url =
        process.env.MIX_AXE_API_URL +
        "users?items=100&organisation_id=" +
        encodeURIComponent(this.organisation_ref);

      if ("" !== search) {
        url += "&search=" + encodeURIComponent(search);
      }

      axios
        .get(url, {
          headers: this.axeHeaders(),
        })
        .then((response) => {
          let assignees = Utils.axeUsers(response.data);

          if (assignees.length > 0) {
            this.assignees = assignees
              .filter((item) => !!item)
              .sort(this.sortByFullName);

            this.assignees_filtered = this.assignees;
          } else {
            this.assignees = [];
            this.assignees_filtered = [];
          }
        })
        .catch((error) => {
          process.appdata.refreshTokens();
        });
    },
    fetch_filtered_organisations(search) {
      axios
        .get(
          process.env.MIX_AXE_API_URL +
            "organisations?items=100&name=" +
            encodeURIComponent(search),
          {
            headers: this.axeHeaders(),
          }
        )
        .then((response) => {
          this.organisations = Utils.axeCollection(response.data).sort(this.sortByName);
          this.organisations_filtered = this.organisations;
        })
        .catch((error) => {
          process.appdata.refreshTokens();
        });
    },
    filter_organisations() {
      clearTimeout(this.organisation_filter_timeout);
      this.organisation_ref = "";

      if ("" !== this.filter.organisation_name) {
        this.organisation_filter_timeout = setTimeout(() => {
          this.fetch_filtered_organisations(this.filter.organisation_name);
        }, 300);
      } else {
        this.fetch_organisations();
      }
    },
    filter_assignees() {
      clearTimeout(this.assignee_filter_timeout);
      this.assignee_id = "";

      if ("" !== this.filter.assignee_name) {
        this.assignee_filter_timeout = setTimeout(() => {
          this.fetch_assignees(this.filter.assignee_name);
        }, 300);
      } else {
        this.fetch_assignees();
      }
    },
    checkout_device() {
      var sessionTokens = Storage.get("session_tokens", true),
        axeTokens = Storage.get("tokens", true);

      if ("" === this.organisation_ref || "" === this.assignee_id) {
        return;
      }

      axios
        .post(
          process.env.MIX_APP_URL +
            "/api/v1/devices/" +
            this.eui +
            "/check_out",
          {
            organisation_id: this.organisation_ref,
            assignee_id: this.assignee_id,
          },
          {
            headers: {
              Authorization:
                sessionTokens.token_type + " " + sessionTokens.access_token,
              "RT-Authorization": axeTokens.access_token,
            },
          }
        )
        .then(
          (response) => {
            if (200 === response.status) {
              this.emitter.emit("device_checked_out");

              let deviceCheckoutModal = bootstrap.Modal.getInstance(
                document.getElementById(this.id)
              );
              deviceCheckoutModal.hide();

              this.emitter.emit("popup_alert", {
                type: "success",
                text: "Device was succesfuly checked out!",
              });
            }
          },
          (error) => {
            this.emitter.emit("popup_alert", {
              type: "danger",
              text: error.message,
            });
          }
        );
    },
  },
  watch: {
    organisation_ref: function () {
      this.filter.assignee_name = "";
      this.fetch_assignees();
    },
  },
};
</script>
